import React, { useState } from "react";
import { NavLink,useNavigate } from "react-router-dom";
import { Row, Col, Container } from 'react-bootstrap'

import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'

function Sidebar({ routes, toggle, toggleHandler1 }) {
  const [isToggle, setIsToggle] = useState(false);
  const navigate = useNavigate();

  const toggleHandler = () => {
    if (toggle || isToggle) setIsToggle(false);
    else setIsToggle(true);
  };

  const exitHandler = (e) => {
    localStorage.removeItem("user_token");
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <BottomSheet
        open={toggle}
        onDismiss={toggleHandler1}
        initialFocusRef={false}
        expandOnContentDrag
      >
        <div>
          <div className="nav">
            {routes.map((prop, key) => {
              if (!prop.redirect && prop.layout === "menu")
                return (
                  <Container>
                    <li key={key} onClick={toggleHandler} className="rgc-nav_link">

                      <NavLink
                        to={prop.path}
                        onClick={toggleHandler1}

                      >
                        <Row className="rgc-nav-content py-2">
                          <Col xs={11} >
                            <i className={prop.icon} />
                            <span className="nav_name">{prop.name}</span>
                          </Col>

                          <Col xs={1} className="me-auto">
                            <i class="fa fa-angle-left"></i>
                          </Col>

                        </Row>
                      </NavLink>


                    </li>
                  </Container>
                );
              return null;
            })}

            <Container>
              <li onClick={toggleHandler} className="rgc-nav_link">
                <Row className="rgc-nav-content py-2" onClick={(e) => exitHandler(e)}>
                  <Col xs={11} >
                    <i className="fas fa-power-off fa-fw  nav_icon"></i>
                    <span className="nav_name">خروج</span>
                  </Col>

                  <Col xs={1} className="me-auto">
                    <i class="fa fa-angle-left"></i>
                  </Col>
                </Row>
              </li>
            </Container>
          </div>

        </div>
      </BottomSheet>
    </>

  );
}

export default Sidebar;
